import type React from 'react';
import styles from './ProductModal.module.scss';
import Picture from '../../../general/Picture/Picture';
import Source from '../../../general/Picture/Source';
import type { CartItem } from '../../Store/CartItem/state';
import Dialog from '../../../../stories/Molecules/Dialog/Dialog';

interface ProductModalProps {
  onClose: () => void;
  product: Pick<CartItem, 'name' | 'previewImage'>;
}

const ProductModal: React.FC<ProductModalProps> = ({ onClose, product }) => (
  <Dialog
    size="md"
    onClose={onClose}
    closeButton
    noPaddingOnBody
    open
  >
    <Dialog.Body>
      <div className={styles.ProductModal__picture}>
        <Picture
          imageClass={styles.ProductModal__image}
          imageUrl={product.previewImage}
          alt={product.name}
        >
          <Source
            imageWidth={600}
            minScreenWidth={600}
          />
          <Source imageWidth={360} />
        </Picture>
      </div>
    </Dialog.Body>
  </Dialog>
);

export default ProductModal;
